/**
 * @voltxampere/ui — M48T02 NVRAM (Sprint 45-5, placeholder)
 *
 * PLACEHOLDER. Parallel bus simulation + battery-backed SRAM
 * Sprint 47+ engine extension #4 ile aktif.
 *
 * Reference: ST M48T02 — DIP-24 / SOIC-28 (battery embedded).
 * NVRAM (Non-Volatile RAM) — 16 Kbit (2 KByte) SRAM + RTC + 10-yıl
 * Li battery internal. V_CC 5 V, parallel address/data bus, write
 * 5 ms. Endüstriyel kontrol, embedded retro/legacy systems, IP/
 * MAC address storage (Sun/SGI workstations 1990'lar).
 *
 *   Default mapping → digital-gate schemaType:
 *     gateFunction = "NOT"
 *     vHigh = 5
 *     propagationDelay = 70e-9  (70 ns parallel access)
 *
 * Engine zero-diff invariant honored — canonical `digital-gate`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const memoryM48t02 = {
    id: "m48t02",
    nameTr: "M48T02 (NVRAM 16Kbit + RTC, DIP-24, placeholder)",
    nameEn: "M48T02 (NVRAM 16Kbit + RTC, DIP-24, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "M48T02",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 70e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=memory-m48t02.js.map